import { Platform } from "../constants";

import { GrinSetupImage } from "./components/grin-setup-image";
import { SetupSection } from "./components/setup-section";
import { OrderedList } from "./components/styled";
import { UTMParamTable } from "./components/utm-param-table";
import { URLVerification } from "./components/utms";
import { type PlatformDetails } from "./platform-details";
import { UtmSpendAdditionalDetails } from "./utm-spend-details";

const PLATFORM = Platform.GRIN;

export const GrinDetails: PlatformDetails = {
  northbeamDocUrl: "",
  officialDocUrl: "",
  additionalDetails: UtmSpendAdditionalDetails(PLATFORM),
};

export const GrinSetup = () => (
  <>
    <SetupSection title="Update parameter pairs in Grin’s URL Details step in creating an ad">
      <OrderedList variant="upper-alpha">
        <>
          Locate ‘Destination URL Paramaters’
          <GrinSetupImage className="mt-4 mb-6" />
        </>
        <>
          Update ‘Destination URL Parameters’ with the values below
          <div className="h-4" />
          <UTMParamTable platform={PLATFORM} />
        </>
      </OrderedList>
    </SetupSection>
    <URLVerification platform={PLATFORM} />
  </>
);
